/**
 * @file: MessageReadersSheet.tsx
 *
 * The "已读" (read-by) list for one of my messages. Pure content — the
 * container supplies the readers and hosts it inside a bottom panel.
 */

import { Typography } from '@euler/app/components/typography';
import { formatChatTime } from '@euler/app/flows/chat/utils/formatChatTime';
import { Avatar } from '@euler/components/Avatar';
import { FontFamily } from '@euler/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { ChatMessageReader } from '@euler/model/chat';
import { FC, memo } from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';

export const MessageReadersSheet: FC<{
  readers: ChatMessageReader[];
  style?: StyleProp<ViewStyle>;
}> = memo(({ readers, style }) => {
  const { rpx } = useResponsiveContext();
  return (
    <View style={[{ paddingHorizontal: rpx(20), paddingTop: rpx(20) }, style]}>
      <Typography.Text
        size={rpx(16)}
        color="#1E293B"
        style={{
          fontFamily: FontFamily.NotoSans.Medium,
          marginBottom: rpx(16),
        }}
      >
        已读 {readers.length > 0 ? `(${readers.length})` : ''}
      </Typography.Text>
      {readers.length === 0 ? (
        <Typography.Text
          size={rpx(13)}
          color="#94A3B8"
          style={{ paddingVertical: rpx(20), textAlign: 'center' }}
        >
          还没有人读过这条消息
        </Typography.Text>
      ) : (
        readers.map(r => (
          <View
            key={String(r.platformUserId)}
            style={{
              flexDirection: 'row',
              alignItems: 'center',
              paddingVertical: rpx(8),
            }}
          >
            <Avatar
              uri={r.avatar ?? undefined}
              name={r.name ?? '?'}
              style={{
                width: rpx(34),
                height: rpx(34),
                borderRadius: rpx(17),
                marginRight: rpx(12),
              }}
            />
            <Typography.Text size={rpx(14)} color="#1E293B" style={{ flex: 1 }}>
              {r.name ?? '未知用户'}
            </Typography.Text>
            <Typography.Text size={rpx(11)} color="#94A3B8">
              {formatChatTime(r.readAt)}
            </Typography.Text>
          </View>
        ))
      )}
    </View>
  );
});
